import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left p-6" }, [
  /*#__PURE__*/_createElementVNode("h3", {
    class: "text-lg leading-6 font-medium text-gray-900",
    id: "modal-title"
  }, "Atendimento encerrado!"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "e agora o que você pretende fazer ?")
  ])
], -1)
const _hoisted_3 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleModal('NEW'))),
        type: "button",
        class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
      }, "Novo Atendimento"),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleModal('CLOSED'))),
        type: "button",
        class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
      }, "Fechar")
    ])
  ]))
}